/*
 * @Author: your name
 * @Date: 2021-09-08 09:25:47
 * @LastEditTime: 2023-12-07 15:58:31
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\mixins\index.js
 */

import * as TemplateData from "@/assets/scripts/programData.js"

export const addMaterialTools = {
  data() {
    return {
    }
  },
  methods: {
    addWindowChild(mediaTemplate, mediaType, index = this.vdrIndex, position) {
      let templateData = this.getTemplateData(mediaType);
      // start 
      // true 为媒体文件 ,false为工具组件
      if (mediaTemplate.id || mediaTemplate.group_id) {

        const baseUrl = process.env.NODE_ENV === 'production' ? window.location.origin : process.env.VUE_APP_IMG;

        templateData.field_item_id = mediaTemplate.id;
        templateData.field_item_nodeKey = this.$uuid.v4();
        templateData.ext_val_name = mediaTemplate.ref_name;
        templateData.ext_val_pimg = mediaTemplate.ref_thumb_url;
        templateData.field_item_path = baseUrl + mediaTemplate.ref_url;
        templateData.ext_val_size = mediaTemplate.ref_size;
        templateData.field_item_playTime = mediaTemplate.ref_time;
        templateData.ext_val_resolution = mediaTemplate.ref_wh;
        templateData.ext_val_duration = mediaTemplate.ref_time < 10 ? 10 : (mediaTemplate.ref_time / 1000);
      } else {
        templateData.field_item_id = this.$uuid.v4();
        templateData.field_item_nodeKey = this.$uuid.v4();
        templateData.ext_val_pimg = mediaTemplate.image;
      }
      templateData.w = this.vdrList[index].w;
      templateData.h = this.vdrList[index].h;
      // end
      if (typeof (position) === 'number' && position < this.vdrList[index].wicket.length) {
        this.vdrList[index].wicket.splice(position, 0, templateData);
        // 激活子级窗口
        this.vdrList[index].activeIndex = position;
      } else {
        this.vdrList[index].wicket.push(templateData);
        // 激活子级窗口
        this.vdrList[index].activeIndex = this.vdrList[index].wicket.length - 1;
      }
      // 激活父级窗口
      this.vdrList[index].active = true;
      // 数据同步
      this.$store.commit("VDR_INDEX", index);
      this.$store.commit("VDR_LIST_EDIT", this.vdrList[index]);
    },
    // 获取窗口数据
    getTemplateData(type) {
      switch (type) {
        case "5": return TemplateData.dataWeather();
        case "12": return TemplateData.dataCountdown();
        case "7": return TemplateData.dataIClock();
        case "2": return TemplateData.dataImage();
        case "14": return TemplateData.dataMedia();
        case "6": return TemplateData.dataNClock();
        case "17": return TemplateData.dataRss();
        case "4": return TemplateData.dataText();
        case "13": return TemplateData.dataTimewait();
        case "1": return TemplateData.dataVideo();
        case "18": return TemplateData.dataWebpage();
        // case "11": return TemplateData.dataCalendar();
        default: return "";
      }
    },
    /**
  * @description: 
  * @param {*} x
  * @param {*} y
  * @param {*} w
  * @param {*} h
  * @return {*}
  */
    addVdrWindow(x = 10, y = 10, w = 0, h = 0) {
      // console.log(x, y, w, h);
      let idMax = -1;
      let zIndexMax = -1;
      this.vdrList.forEach((vdr) => {
        vdr.idx > idMax && (idMax = vdr.idx);
        vdr.zIndex > zIndexMax && (zIndexMax = vdr.zIndex);
      });
      this.$store.commit("VDR_LIST_ADD", {
        type: "10",
        field: `wicket_${this.$uuid.v4()}`,
        id: `id_${this.$uuid.v4()}`,
        field_cn: "窗口",
        idx: idMax + 1,
        zIndex: zIndexMax + 1,  // 组件当前层级
        activeIndex: 0,  // 当前激活子组件
        active: false,  //是否立即激活
        style: {
          fs: "0",
          ha: "0",
          va: "0"
        },
        x: x,
        y: y,
        w: w !== 0 ? w : parseInt(this.vdrInfor.w * 0.25),
        h: h !== 0 ? h : parseInt(this.vdrInfor.h * 0.25),
        wicket: []
      });
      this.$store.commit("VDR_INDEX", this.vdrListLength - 1);

      setTimeout(() => {
        if (this.vdrListLength === 1 && (this.grids[0].length + this.grids[1].length === 0)) {
          this.$store.commit("VDR_WIN_FULL", { x: 0, y: 0, w: this.vdrWindowSize.vdrw, h: this.vdrWindowSize.vdrh });
          this.setStyle('fs', 1);
        }
      }, 100);
    },
    setStyle(key, val) {
      let wicket = this.vdrList[this.vdrIndex].wicket;
      if (wicket.length === 0) { return; }
      let activeIndex = this.vdrList[this.vdrIndex].activeIndex;
      wicket[activeIndex].style[key] = val;
      this.$store.commit("VDR_LIST_EDIT", this.vdrList[this.vdrIndex]);
    }
  },
  computed: {
    vdrList() {
      return this.$store.state.program.vdrList;
    },
    vdrWindowSize() {
      return this.$store.state.program.vdrWindowSize;
    },
    vdrIndex() {
      return this.$store.state.program.vdrIndex;
    },
    ratio() {
      return this.$store.state.program.ratio;
    },
    vdrListLength() {
      return this.$store.getters.getVdrListLength;
    },
    grids() {
      return this.$store.state.program.grids
    },
  }
}